module.exports = __webpack_public_path__ + "static/parallax-24eecfdc8249dded25dc88a78e4f81de.jpg";